import { Dispatch, FunctionComponent, useMemo } from 'react';
import { VoucherCheckoutState } from '../../../vouchersState';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { GiftAmountRadio } from '../GiftAmountRadio';

const DEFAULT_AMOUNTS = [25, 50, 100];

export const AmountSelector: FunctionComponent<{
    state: VoucherCheckoutState;
    dispatch: Dispatch<Partial<VoucherCheckoutState>>;
}> = ({ state, dispatch }) => {
    const isDefaultAmount = useMemo(
        () => DEFAULT_AMOUNTS.some((x) => x === Number(state.amount)),
        [state.amount]
    );

    return (
        <div className={styles.amounts_container}>
            {DEFAULT_AMOUNTS.map((amount) => (
                <GiftAmountRadio
                    key={amount}
                    amount={amount}
                    setAmount={(amount) => dispatch({ amount })}
                    isSelected={state.amount === amount}
                    currency={state.educator.primaryCurrency}
                />
            ))}
            <input
                type="number"
                min="1"
                value={isDefaultAmount ? '' : state.amount}
                onChange={(e) => dispatch({ amount: Number(e.target.value) })}
                placeholder="Enter any amount"
                name="custom_gift_amount_input"
                className={classNames(styles.amount_number_input, {
                    [`${styles.amount_number_input_selected}`]: !isDefaultAmount,
                })}
            />
        </div>
    );
};
